import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  requestStart,
  requestFailure,
  fetchOrdersSuccess,
  createOrderSuccess
} from './orderSlice';
import { billingClient } from 'api/clients';

// Fetch all orders
export const fetchAllOrdersThunk = createAsyncThunk(
  'order/fetchAllOrders',
  async (_, { dispatch }) => {
    dispatch(requestStart());
    try {
      const data = await billingClient.getOrders();
      dispatch(fetchOrdersSuccess(data));
    } catch (error) {
      dispatch(requestFailure(error.toString()));
    }
  }
);

// Create new order
//#TODO: uncomment the code, remove placeholder
export const createNewOrderThunk = createAsyncThunk(
  'order/createNewOrder',
  async (formData, { dispatch }) => {
    // dispatch(requestStart());
    try {
      await fetch('https://jsonplaceholder.typicode.com/posts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      // const data = await billingClient.createOrder(formData);
      // if (!data || data.error) {
      //   throw new Error('Failed to create order');
      // }
      dispatch(createOrderSuccess(formData));
      return formData;
    } catch (error) {
      dispatch(requestFailure(error.toString()));
    }
  }
);
